import BigNumber from 'bignumber.js'
import erc20ABI from 'config/abi/erc20.json'
import multicall from 'utils/multicall'
import { getAddress, getZapAddress } from 'utils/addressHelpers'
import { Currency } from 'config/constants/types'
import { simpleRpcProvider } from 'utils/providers'

const fetchTokenBalancesUserData = async (account: string, tokensToFetch: Currency[]) => {
  const calls = tokensToFetch.map((token) => {
    const tokenAddress = getAddress(token.address)
    return {
      address: tokenAddress,
      name: 'balanceOf',
      params: [account],
    }
  })

  const rawTokenBalances = await multicall(erc20ABI, calls)
  const parsedTokenBalances = rawTokenBalances.map((tokenBalance) => {
    return new BigNumber(tokenBalance).toJSON()
  })

  // FTM tokens
  const ftmBalance = await simpleRpcProvider.getBalance(account)
  const ftmNumberBalance = new BigNumber(ftmBalance.toString()).toJSON()

  const nativeBalance = [ftmNumberBalance]
  return [...nativeBalance, ...parsedTokenBalances.slice(1)]
}

const fetchTokenAllowancesUserData = async (account: string, vaultsToFetch: Currency[]) => {
  const calls = vaultsToFetch.map((vault) => {
    const contractAddress = getZapAddress()
    const tokenAddress = getAddress(vault.address)
    return { address: tokenAddress, name: 'allowance', params: [account, contractAddress] }
  })
  const rawAllowances = await multicall(erc20ABI, calls)
  const parsedAllowances = rawAllowances.map((balance) => {
    return new BigNumber(balance).toJSON()
  })
  return parsedAllowances
}

export { fetchTokenBalancesUserData, fetchTokenAllowancesUserData }
